import React from "react";
import PropTypes from "prop-types";

import { Button as ButtonStyled } from "./style";

ButtonStyled.propTypes = {
  primary: PropTypes.bool
};

export default ButtonStyled;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/nicolasraynaud/Projets/jeux-mobiles-manitoba/packages/common-react/lib/components/Button/index.js
// module id = 20
// module chunks = 0